import { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";
import { useAuth } from "../contexts/authContext";  // import the auth context hook

export default function Register() {
  const [form, setForm] = useState({ email: "", password: "", name: "" });
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const { login, setName } = useAuth();  // get the login function from context

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await apiClient.post(`/auth/register`, form);
      login(res.data.token, res.data.user._id);
      setName(form.name);
      navigate("/onboard/welcome");
    } catch (err) {
      if (err.response && err.response.status === 400) {
        setError("An account with this email already exists.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    }
  };

  const [keyboardOffset, setKeyboardOffset] = useState(0);
  // Keyboard Event Handling for Android
  useEffect(() => {
    if (Capacitor.getPlatform() === 'android') {
      const showSub = Keyboard.addListener('keyboardWillShow', (info) => {
        setKeyboardOffset(info.keyboardHeight || 300); // fallback height
      });
      const hideSub = Keyboard.addListener('keyboardWillHide', () => {
        setKeyboardOffset(0);
      });

      return () => {
        showSub.remove();
        hideSub.remove();
      };
    }
  }, []);

  return (
    <div
      className="min-h-screen bg-cover bg-center flex flex-col text-center font-sans" //min-h-[100dvh]
      style={{ backgroundImage: "url('assets/splash-1.jpg')" }}
    >
      {/* App Title */}
      <h1 className="text-5xl font-light tracking-tight text-[#1F2937] pt-8 pb-4">
        Sous
      </h1>

      {/* Centered Form Area */}
      <div className="flex-1 flex items-center justify-center overflow-y-auto px-4 py-8 style={{ paddingBottom: `${keyboardOffset}px` }}">
        <div className="bg-white backdrop-blur-sm rounded-xl p-6 max-w-md w-full shadow-lg space-y-6">
          <h2 className="text-xl font-semibold text-charcoal">
            Register with Sous
          </h2>
          <form
            onSubmit={handleSubmit}
            className="space-y-4 text-left text-slate-800"
          >
           {error && <p className="text-red-500 text-sm">{error}</p>}
           <input
              className="w-full p-2 border border-slate-300 rounded"
              type="text"
              name="name"
              placeholder="First name"
              onChange={handleChange}
              required
            />
            <input
              className="w-full p-2 border border-slate-300 rounded"
              type="email"
              name="email"
              placeholder="Email"
              inputMode="email" 
              autoComplete="email"
              onChange={handleChange}
              required
            />
            <input
              className="w-full p-2 border border-slate-300 rounded"
              type="password"
              name="password"
              placeholder="Password"
              autoComplete="new-password"
              onChange={handleChange}
              required
            />
            <button
              type="submit"
              className="w-full bg-charcoal text-white p-2 rounded-3xl hover:bg-charcoal/80 transition"
            >
              Register
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
